module.exports = __webpack_public_path__ + "img/network.77259ab4.png";